import { Navigate, Outlet } from 'react-router-dom';
import { PageHeader } from '../../components/PageHeader';
import { useSession } from '../../session';

/**
 * The system management console: the platform itself, rather than anybody's workspace.
 *
 * Everything here crosses tenants — a stack trace can name another customer's org, an invite code decides
 * who gets onto the platform at all, and a signing key is the one credential every tenant depends on — so
 * the whole area is for accounts flagged is_operator in the database. That flag is set from the command
 * line and never through the API, which is what keeps this from being something an account can grant
 * itself.
 *
 * These pages used to hang off the top-level navigation one at a time; they are now one entry in the side
 * menu, which unfolds into the four of them while you are here. Gathering them is not tidying: an
 * operator handling an incident is reading the error log and rotating a key in the same ten minutes, and
 * those two things belonging to one place is most of what makes them findable.
 */
export function Console() {
  const { me, loading } = useSession();
  if (loading) return <p className="muted">Loading…</p>;
  // A non-operator is not told what is here. Every route underneath refuses them server-side as well.
  if (!me?.isOperator) return <Navigate to="/" replace />;

  return (
    <>
      <PageHeader
        crumbs={[{ label: 'Platform' }]}
        title="Console"
        meta="Kruvi Access itself: who is on it, what has gone wrong, and the key everything is signed with."
      />

      <Outlet />
    </>
  );
}
